import { Component } from '@theme/component';

class ContactPanelComponent extends Component {
  #isOpen = false;
  #justOpened = false;

  connectedCallback() {
    super.connectedCallback();
    this.#bindTrigger();
    this.#bindCloseButton();
    this.#bindOutsideClick();
    this.#bindEscape();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#handleOutsideClick);
    document.removeEventListener('keydown', this.#handleEscape);
  }

  toggle() {
    if (this.#isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.#isOpen = true;
    this.#justOpened = true;
    requestAnimationFrame(() => {
      this.#justOpened = false;
    });

    this.classList.add('contact-panel--open');

    const trigger = this.refs.trigger;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  close() {
    this.#isOpen = false;
    this.classList.remove('contact-panel--open');

    const trigger = this.refs.trigger;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  #bindTrigger() {
    const trigger = this.refs.trigger;
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });
  }

  #bindCloseButton() {
    const closeBtn = this.refs.closeBtn;
    if (!closeBtn) return;

    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.close();
      this.refs.trigger?.focus();
    });
  }

  #bindOutsideClick() {
    document.addEventListener('click', this.#handleOutsideClick);
  }

  #handleOutsideClick = (e) => {
    if (!this.#isOpen) return;
    if (this.#justOpened) return;
    if (this.contains(e.target)) return;
    if (e.target.closest?.('[data-contact-trigger]')) return;
    this.close();
  };

  #bindEscape() {
    document.addEventListener('keydown', this.#handleEscape);
  }

  #handleEscape = (e) => {
    if (e.key !== 'Escape') return;
    if (!this.#isOpen) return;
    this.close();
    this.refs.trigger?.focus();
  };
}

customElements.define('contact-panel-component', ContactPanelComponent);
